import React from "react";
import { Phone, MessageCircle } from "lucide-react";

export default function FloatingActions() {
  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3" data-testid="floating-actions">
      <a
        href="https://wa.me/34722797599?text=Hola%2C%20quiero%20pedir%20una%20revisi%C3%B3n%20auditiva%20gratuita"
        target="_blank"
        rel="noreferrer"
        className="grid place-items-center w-14 h-14 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white shadow-lg hover:shadow-xl transition-all"
        aria-label="WhatsApp"
        data-testid="floating-whatsapp"
      >
        <MessageCircle className="w-7 h-7" />
      </a>
      <a
        href="tel:+34965637618"
        className="grid place-items-center w-14 h-14 rounded-full bg-blue-900 hover:bg-blue-800 text-white shadow-lg hover:shadow-xl transition-all"
        aria-label="Llamar"
        data-testid="floating-call"
      >
        <Phone className="w-7 h-7" />
      </a>
    </div>
  );
}
